import * as React from "react";
import { Router } from "@reach/router";
import { RouterOutlet } from "kw/components/RouterOutlet/RouterOutlet";
import { AccountSummaryPage } from "./pages/AccountSummaryPage";
import { Error404Page } from "kw/quoting/pages/Error404Page";

export function AccountMain() {
  return (
    <Router basepath="/account">
      <Error404Page default />
      <RouterOutlet
        component={AccountSummaryPage}
        path="/"
        layoutOverrides={{
          showHeader: true,
          hideBackButton: true,
          headerText: "Account & Settings",
          headerTextCenter: true,
        }}
      />
    </Router>
  );
}
